import CityPageTemplate from "../city-template/CityPageTemplate";
import { phoenixConfig } from "./data";

export default function PhoenixPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "@id": "https://fastpassportcenter.com/cities/phoenix/#office",
            name: "Fast Passport Center — Phoenix Office",
            image: "https://storage.readdy-site.link/project_files/5b15eb5b-af79-4c03-9ad0-73c6095d69a7/39b34e24-6cae-4aa4-bcd8-dc68c850858b_compressed_phoenix-az---office.webp",
            description:
              "Fast Passport Center is a registered U.S. Department of State passport courier serving Phoenix, Scottsdale, Mesa, Chandler, Tempe, Glendale, and all of Maricopa County with expedited passport processing as fast as 24 hours. A+ BBB rated. Located at 4742 N 24th St in the Camelback East corridor.",
            url: "https://fastpassportcenter.com/cities/phoenix/",
            telephone: "+1-877-253-0084",
            email: "info@fastpassportcenter.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "4742 N 24th St",
              addressLocality: "Phoenix",
              addressRegion: "AZ",
              postalCode: "85016",
              addressCountry: "US",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "33.4484",
              longitude: "-112.0740",
            },
            openingHoursSpecification: [
              {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                opens: "09:00",
                closes: "18:00",
              },
              {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: "Saturday",
                opens: "10:00",
                closes: "14:00",
              },
            ],
            priceRange: "$$$",
            areaServed: [
              { "@type": "City", name: "Phoenix" },
              { "@type": "City", name: "Scottsdale" },
              { "@type": "City", name: "Mesa" },
              { "@type": "City", name: "Chandler" },
              { "@type": "City", name: "Gilbert" },
              { "@type": "City", name: "Glendale" },
              { "@type": "City", name: "Tempe" },
              { "@type": "City", name: "Peoria" },
              { "@type": "AdministrativeArea", name: "Maricopa County" },
            ],
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.9",
              reviewCount: "1200",
            },
            hasMap:
              "https://maps.google.com/maps?q=4742+N+24th+St,+Phoenix,+AZ+85016",
            sameAs: [
              "https://maps.google.com/maps?daddr=4742+N+24th+St,+Phoenix,+AZ+85016",
            ],
          }),
        }}
      />
      <CityPageTemplate config={phoenixConfig} />
    </>
  );
}